import React from "react";
import {
  Box,
  Typography,
  Grid,
  Paper,
  Button,
} from "@mui/material";

const ReformationReviewSection = ({ section }) => {
  // Extract brandActions data from the section
  const brandActions = section.brandActions || {};
  
  // Get approval status and note from brandActions
  const approvalStatus = brandActions.status || "Yet to be reviewed";
  const noteToVendor = brandActions.noteToVendor || "-";

  // Function to get status button styling based on approval status
  const getStatusButtonStyling = (status) => {
    switch (status?.toLowerCase()) {
      case "approve":
      case "approved":
        return {
          borderColor: "#137333",
          backgroundColor: "#E6F4EA",
          color: "#137333",
        };
      case "reject":
      case "rejected":
        return {
          borderColor: "#B91C1C",
          backgroundColor: "#FEE2E2",
          color: "#B91C1C",
        };
      case "pending":
        return {
          borderColor: "#B45309",
          backgroundColor: "#FEF3C7",
          color: "#B45309",
        };
      default:
        return {
          borderColor: "#344054",
          backgroundColor: "#F2F4F7",
          color: "#344054",
        };
    }
  };

  return (
    <Box sx={{ mt: 4, mb: 4 }}>
      <Paper
        sx={{
          boxShadow: "none",
          mt: 4,
          p: 4,
          borderRadius: "8px",
          backgroundColor: "#33331110",
        }}
      >
        {/* Section Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 3,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              color: "#333333",
              fontWeight: 600,
              fontSize: "16px",
              mb: "5px",
            }}
          >
            Reformation Review Section
          </Typography>
        </Box>

        {/* Content Grid */}
        <Grid container spacing={3}>
          {/* Approval Status */}
          <Grid item xs={12} md={6}>
            <Box>
              <Typography
                variant="subtitle1"
                sx={{
                  color: "#333333",
                  fontWeight: 600,
                  fontSize: "16px",
                  mb: 2,
                }}
              >
                Approval Status:
              </Typography>
              <Button
                variant="outlined"
                disabled
                sx={{
                  ...getStatusButtonStyling(approvalStatus),
                  fontWeight: 600,
                  textTransform: "none",
                  borderRadius: "6px",
                  padding: "8px 16px",
                  fontSize: "14px",
                  "&:disabled": {
                    ...getStatusButtonStyling(approvalStatus),
                  },
                }}
              >
                {approvalStatus}
              </Button>
            </Box>
          </Grid>

          {/* Note From Reformation */}
          <Grid item xs={12} md={6}>
            <Box>
              <Typography
                variant="subtitle1"
                sx={{
                  color: "#333333",
                  fontWeight: 600,
                  fontSize: "16px",
                  mb: 2,
                }}
              >
                Note From Reformation:
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: "#333333",
                  fontSize: "14px",
                }}
              >
                {noteToVendor}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default ReformationReviewSection; 